import React, { useState } from "react";
import PropTypes from "prop-types";
import { useAddHolidayMutation } from "src/api/holidaysApiSlice";
import { Button, DatePicker, Input } from "antd";

const AddHoliday = (props) => {
  const [addHoliday, isLoading] = useAddHolidayMutation();
  const [selectedDate, setSelectedDate] = useState(null);
  const [reasonText, setReasonText] = useState("");
  const handleChange = (date, dateString) => {
    console.log(date, dateString);
    setSelectedDate(date);
  };
  const handleAdd = () => {
    // alert("handleAdd");
    addHoliday({
      date: selectedDate,
      description: reasonText,
    });
  };
  const handleInputChange = (event) => {
    setReasonText(event.target.value);
  };

  function disabledDate(current) {
    // Can not select days before today and today
    return current && current.valueOf() < Date.now();
  }
  return (
    <div>
      <div>Add Holiday</div>
      <DatePicker onChange={handleChange} disabledDate={disabledDate} />
      <Input
        value={reasonText}
        onChange={handleInputChange}
        placeholder="Basic usage"
      />

      <Button
        disabled={!selectedDate || !reasonText}
        type="primary"
        onClick={() => {
          handleAdd();
        }}
      >
        Add Holiday
      </Button>
    </div>
  );
};

export { AddHoliday };
